<template>
    <img src="@/assets/home/ball-l.png" alt="" class="ani-ele ball-l" />
    <img src="@/assets/home/ball-r.png" alt="" class="ani-ele ball-r" />
    <img src="@/assets/home/star1.png" alt="" class="ani-ele star1" />
    <img v-if="state.showStar2" src="@/assets/home/star2.png" alt="" class="ani-ele star2" />
    <img src="@/assets/home/star3.png" alt="" class="ani-ele star3" />
    <img src="@/assets/home/star4.png" alt="" class="ani-ele star4" />
    <img v-if="state.showStar5" src="@/assets/home/star5.png" alt="" class="ani-ele star5" />
    <img src="@/assets/home/star6.png" alt="" class="ani-ele star6" />
    <img src="@/assets/home/star7.png" alt="" class="ani-ele star7" />
</template>
<script setup>
import { onMounted, reactive } from "@vue/runtime-core"
const state = reactive({
    showStar5: false,
    showStar2: false
})
onMounted(()=>{
    setTimeout(()=>{
        state.showStar5 = true
    }, 1250)
    setTimeout(()=>{
        state.showStar2 = true
    }, 3000)
})
</script>
<style scoped>
.ani-ele{
    position: absolute;
    z-index: -1;
    user-select: none;
}
.ball-l{
    width: 479rem;
    left: 0;
    top: 0;
    animation: ball-l-ani 10000ms linear infinite;
}
@keyframes ball-l-ani {
    0%{
        transform: translateY(-20rem);
    }
    50%{
        transform: translateY(0);
    }
    100%{
        transform: translateY(-20rem);
    }
}

.ball-r{
    width: 479rem;
    right: 0;
    top: 140rem;
    animation: ball-r-ani 10000ms linear infinite;
}
@keyframes ball-r-ani {
    0%{
        transform: translateY(20rem);
    }
    50%{
        transform: translateY(0);
    }
    100%{
        transform: translateY(20rem);
    }
}
/* 左1区块链 */
.star1{
    width: 279rem;
    top: 480rem;
    left: 110rem;
    animation: star1-ani 10000ms linear infinite;
}
@keyframes star1-ani {
    0%{
        transform: translateY(-28rem);
        opacity: 1;
    }
    50%{   
        transform: translateY(0);
        opacity: 0.3;
    }
    100%{
        transform: translateY(-28rem);
        opacity: 1;
    }
}
/* 背景区块链1 */
.star2{
    width: 117rem;
    top: 283rem;
    left: 400rem;
    animation: star7-ani 5500ms linear infinite 1500ms;
}
/* @todo间隔 3000ms */
/* 左2区块链 */
.star3{
    width: 279rem;
    top: 70rem;
    left: 590rem;
    animation: star3-ani 10000ms infinite;
}
@keyframes star3-ani {
    0%{
        transform: translateY(28rem);
        opacity:0.3;
    }
    50%{   
        transform: translateY(0);
        opacity: 1;
    }
    100%{
        transform: translateY(28rem);
        opacity: 0.3;
    }
}
/* 右2区块链 */
.star4{
    width: 280rem;
    top: 170rem;
    left: 1010rem;
    animation: star1-ani 10000ms linear infinite;
}

/* 背景区块链2 */
.star5{
    width: 135rem;
    top: 79rem;
    left: 1268rem;
    animation: star7-ani 4000ms linear infinite;
}
/* 右1区块链 */
.star6{
    width: 279rem;
    /* right: 205rem; */
    left: 1436rem;
    top: 86rem;
    animation: star3-ani 10000ms linear infinite;
}
/* 背景区块链3 */
.star7{
    width: 135rem;
    /* right: 4rem; */
    left: 1780rem;
    top: 120rem;
    animation: star7-ani 2500ms linear infinite 1500ms;
}
@keyframes star7-ani {
    0%{
        opacity: 0;
    }
    20%{   
        opacity: 0.2;
    }
    50%{
        opacity: 1;
    }
    80%{   
        opacity: 0.2;
    }
    100%{
        opacity: 0;
    }
}
</style>